module.exports = __webpack_public_path__ + "img/20190724155859QQ截图20190724000310.93e16a57.png";